module.exports = __webpack_public_path__ + "img/Prudence_text02_moderate.814f785b.png";